import { ApolloClient } from '@apollo/client';

import {
  finleyAssert,
  utils as commonUtils,
} from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

import { GET_PIPELINE_UPLOAD_SIGNED_URL } from 'packages/files/requests/files.gql';
import { presignedPostUpload } from 'packages/files/ui/utils';

export const getTitleCaseExternalFilename = (filename: string): string => {
  const splitOnForwardSlash = filename.split('/');
  return commonUtils.toTitleCase(splitOnForwardSlash.slice(1).join(' '));
};

// The helper throws and captures a sentry exception if an error occurs
export const directUpload = async ({
  client,
  file,
  organizationId,
  artifactId,
  reportingDate,
  onEventCallback,
}: {
  client: ApolloClient<object>;
  file: File;
  organizationId: string;
  artifactId: string;
  reportingDate: Util.FullDateStr;
  onEventCallback: (loaded: number, total: number) => void;
}): Promise<string> => {
  // The helper throws and captures a sentry exception if an error occurs
  const { queryResponse } = await presignedPostUpload<
    {
      organizationId: string;
      artifactId: string;
      reportingDate: Util.FullDateStr;
    },
    { artifactInstanceId: string }
  >({
    client,
    file,
    query: GET_PIPELINE_UPLOAD_SIGNED_URL,
    queryVariables: {
      organizationId,
      artifactId,
      reportingDate,
    },
    progressEventCallback: ({ loaded, total }) => {
      onEventCallback(loaded, total);
    },
  });

  finleyAssert(
    queryResponse.artifactInstanceId,
    'BBPL artifact instance id missing.',
  );

  return queryResponse.artifactInstanceId;
};
